import React from 'react';
import PropTypes from 'prop-types';
import '../css/fainlearnLoadingSvg.css';

export default function FainlearnLoadingSvg({ width = '100', height = '100' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 768 768"
      height={height}
      version="1.0"
    >
      <path
        fill="#2971D9"
        d="M 218.691406 112.699219 L 234.242188 97.144531 C 258.070312 73.558594 296.945312 75.066406 318.769531 100.40625 L 533.976562 351.289062 C 552.769531 373.121094 552.539062 405.480469 533.46875 427.058594 L 319.019531 670.15625 C 296.945312 694.996094 258.570312 696.238281 234.996094 672.660156 L 219.445312 657.101562 C 198.375 636.027344 196.871094 602.429688 215.933594 579.332031 L 344.351562 425.289062 C 361.910156 404.214844 362.160156 373.859375 345.105469 352.277344 L 214.679688 189.214844 C 196.117188 166.636719 197.875 133.519531 218.691406 112.695312 Z M 218.691406 112.699219"
        className="svg-elem-1"
      />
      <path
        fill="#FFB96B"
        d="M 344.101562 425.796875 L 215.683594 579.839844 C 196.621094 602.660156 198.125 636.535156 219.195312 657.609375 L 234.742188 673.167969 C 258.320312 696.746094 296.695312 695.503906 318.769531 670.660156 L 365.167969 617.964844 C 382.726562 583.355469 392.507812 544.21875 392.507812 502.828125 C 392.507812 451.652344 377.460938 404.21875 351.875 364.324219 C 361.40625 383.902344 358.898438 408.238281 344.101562 425.796875 Z M 344.101562 425.796875"
        className="svg-elem-2"
      />
      <path
        fill="#1975FF"
        d="M 240.199219 348.160156 C 220.316406 348.160156 204.199219 364.277344 204.199219 384.160156 C 204.199219 404.039062 220.316406 420.160156 240.199219 420.160156 C 260.082031 420.160156 276.199219 404.039062 276.199219 384.160156 C 276.199219 364.277344 260.082031 348.160156 240.199219 348.160156"
        className="svg-elem-3"
      />
      <path
        fill="#1975FF"
        d="M 537.386719 540.800781 C 517.503906 540.800781 501.386719 556.917969 501.386719 576.800781 C 501.386719 596.683594 517.503906 612.800781 537.386719 612.800781 C 557.269531 612.800781 573.386719 596.683594 573.386719 576.800781 C 573.386719 556.917969 557.269531 540.800781 537.386719 540.800781"
        className="svg-elem-4"
      />
      <path
        fill="#1975FF"
        d="M 537.386719 146.996094 C 517.503906 146.996094 501.386719 163.113281 501.386719 182.996094 C 501.386719 202.878906 517.503906 218.996094 537.386719 218.996094 C 557.269531 218.996094 573.386719 202.878906 573.386719 182.996094 C 573.386719 163.113281 557.269531 146.996094 537.386719 146.996094"
        className="svg-elem-5"
      />
    </svg>
  );
}

FainlearnLoadingSvg.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};
